import Joi from './joi'

export const isValidUrl = (url: string) => {
  const { error } = Joi.url().validate(url)

  return url && !error
}
